import { api, type ApiResponse } from "./client";
import type { Channel } from "@/types/channel";

export interface WhatsAppStatus {
  session_id?: string;
  phone_number?: string;
  status: string;
  connected: boolean;
  logged_in: boolean;
  jid?: string;
}

export interface QRCodeData {
  status: string;
  qr?: string;
  message?: string;
}

export interface ConnectData {
  status: string;
  qr_required: boolean;
}

export interface ProvisionData {
  external_id: string;
}

export const channelsApi = {
  list: (params?: Record<string, string>): Promise<ApiResponse<Channel[]>> =>
    api.get("/channels", params),

  get: (id: number): Promise<ApiResponse<Channel>> =>
    api.get(`/channels/${id}`),

  create: (data: Partial<Channel>): Promise<ApiResponse<Channel>> =>
    api.post("/channels", data),

  update: (id: number, data: Partial<Channel>): Promise<ApiResponse<Channel>> =>
    api.put(`/channels/${id}`, data),

  delete: (id: number): Promise<ApiResponse<Channel>> =>
    api.del(`/channels/${id}`),

  // WhatsApp management
  connect: (id: number): Promise<ApiResponse<ConnectData>> =>
    api.post(`/channels/${id}/connect`, {}),

  getQR: (id: number): Promise<ApiResponse<QRCodeData>> =>
    api.get(`/channels/${id}/qr`),

  getWhatsAppStatus: (id: number): Promise<ApiResponse<WhatsAppStatus>> =>
    api.get(`/channels/${id}/whatsapp-status`),

  disconnect: (id: number): Promise<ApiResponse<{ status: string }>> =>
    api.post(`/channels/${id}/disconnect`, {}),

  logout: (id: number): Promise<ApiResponse<{ status: string }>> =>
    api.post(`/channels/${id}/logout`, {}),

  provision: (id: number): Promise<ApiResponse<ProvisionData>> =>
    api.post(`/channels/${id}/provision`, {}),
};
